import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { deactivateAccount, accountReactivationLink, getAccountStatus } from '../../services/AccountActivations/accountActivations';
import { toastNotify } from '../../utils/toastNotify';
const initialState = {
  loading: false,
  data: {},
};
export const featchAccountStatusAction = createAsyncThunk('FEATCH_ACCOUNT_STATUS', getAccountStatus);
export const accountDeactivationAction = createAsyncThunk('ACCOUNT_DEACTIVATION_ACTION', deactivateAccount);
export const accountReactivationLinkAction = createAsyncThunk('SEND_ACCOUNT_REACTIVATION_LINK', accountReactivationLink);

export const accountActivationSlice = createSlice({
  name: 'propertyDetails',
  initialState,
  extraReducers: {
    [accountDeactivationAction.pending]: (state, action) => {
      return {
        ...state,
        loading: true,
      };
    },
    [accountDeactivationAction.fulfilled]: (state, action) => {
      return {
        ...state,
        loading: false,
      };
    },
    [accountDeactivationAction.rejected]: (state, action) => {
      toastNotify('error', action.payload);
      return {
        ...state,
        loading: false,
        data: {},
      };
    },
    [featchAccountStatusAction.pending]: (state, action) => {
      return {
        ...state,
        loading: true,
      };
    },
    [featchAccountStatusAction.fulfilled]: (state, action) => {
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    },
    [featchAccountStatusAction.rejected]: (state, action) => {
      toastNotify('error', action.payload);
      return {
        ...state,
        loading: false,
        data: {},
      };
    },
    [accountReactivationLinkAction.pending]: (state, action) => {
      return {
        ...state,
        loading: true,
      };
    },
    [accountReactivationLinkAction.fulfilled]: (state, action) => {
      toastNotify('success', action.payload.message);
      return {
        ...state,
        loading: false,
      };
    },
    [accountReactivationLinkAction.rejected]: (state, action) => {
      toastNotify('error', action.payload);
      return {
        ...state,
        loading: false,
        data: {},
      };
    },
  },
});
const { reducer } = accountActivationSlice;
export default reducer;
